import Pikaday from 'pikaday';

import ll_messages from "./ll_messages";
import Lang from "lang.js";
const default_locale = window.default_locale;
const fallback_locale = window.fallback_locale;

const lang = new Lang({
    messages: ll_messages,
    locale: default_locale,
    fallback: fallback_locale
});

const lang_settings = {
    previousMonth: lang.get('kalendar.mesic_predchozi'),
    nextMonth: lang.get('kalendar.mesic_nasledujici'),
    months: [
        lang.get('kalendar.mesic_1'),
        lang.get('kalendar.mesic_2'),
        lang.get('kalendar.mesic_3'),
        lang.get('kalendar.mesic_4'),
        lang.get('kalendar.mesic_5'),
        lang.get('kalendar.mesic_6'),
        lang.get('kalendar.mesic_7'),
        lang.get('kalendar.mesic_8'),
        lang.get('kalendar.mesic_9'),
        lang.get('kalendar.mesic_10'),
        lang.get('kalendar.mesic_11'),
        lang.get('kalendar.mesic_12')
    ],
    weekdays: [
        lang.get('kalendar.den_v_tydnu_0'),
        lang.get('kalendar.den_v_tydnu_1'),
        lang.get('kalendar.den_v_tydnu_2'),
        lang.get('kalendar.den_v_tydnu_3'),
        lang.get('kalendar.den_v_tydnu_4'),
        lang.get('kalendar.den_v_tydnu_5'),
        lang.get('kalendar.den_v_tydnu_6'),
    ],
    weekdaysShort: [
        lang.get('kalendar.den_v_tydnu_zkratka_0'),
        lang.get('kalendar.den_v_tydnu_zkratka_1'),
        lang.get('kalendar.den_v_tydnu_zkratka_2'),
        lang.get('kalendar.den_v_tydnu_zkratka_3'),
        lang.get('kalendar.den_v_tydnu_zkratka_4'),
        lang.get('kalendar.den_v_tydnu_zkratka_5'),
        lang.get('kalendar.den_v_tydnu_zkratka_6'),
    ],
};

var startDate,
    endDate,
    updateStartDate = function() {
        let date = new Date(Date.parse(startDate.toDateString()));

        let day = parseInt(('0' + date.getDate()).slice(-2));
        let month = ('0' + (date.getMonth() + 1)).slice(-2);
        let year = date.getFullYear();

        endPicker.gotoDate(new Date(year, month - 1))
        endPicker.setMinDate(new Date(year, month - 1, day + 1));
    },
    startPicker = new Pikaday({
        field: document.getElementById('datum_od'),
        minDate: new Date(Date.now() + (document.getElementById('datum_od') ? document.getElementById('datum_od').dataset.dni : 0) * 24 * 60 * 60 * 1000),
        format: 'DD.MM.YYYY',
        firstDay: 1,
        i18n: lang_settings,
        onSelect: function() {
            startDate = this.getDate();
            updateStartDate();
        }
    }),

    endPicker = new Pikaday({
        field: document.getElementById('datum_do'),
        format: 'DD.MM.YYYY',
        firstDay: 1,
        i18n: lang_settings,
        minDate: new Date(),
        onSelect: function() {
            endDate = this.getDate();
        }
    }),

    _startDate = startPicker.getDate(),
    _endDate = endPicker.getDate();

if (_startDate) {
    startDate = _startDate;
    updateStartDate();
}

if (_endDate) {
    endDate = _endDate;
}
